export function getEchoSocketId(echo = globalThis.window?.Echo) {
  if (!echo || typeof echo.socketId !== 'function') {
    return null
  }

  const socketId = echo.socketId()

  if (typeof socketId !== 'string') {
    return null
  }

  const trimmedSocketId = socketId.trim()

  if (
    !trimmedSocketId ||
    ['null', 'undefined'].includes(trimmedSocketId.toLowerCase())
  ) {
    return null
  }

  return trimmedSocketId
}

export function applyEchoSocketIdHeader(
  headers,
  echo = globalThis.window?.Echo
) {
  const socketId = getEchoSocketId(echo)

  if (socketId) {
    headers['X-Socket-ID'] = socketId

    return
  }

  delete headers['X-Socket-ID']
}
